import { render, staticRenderFns } from "./account-title.vue?vue&type=template&id=797260eb&scoped=true&"
import script from "./account-title.vue?vue&type=script&lang=js&"
export * from "./account-title.vue?vue&type=script&lang=js&"
import style0 from "./account-title.vue?vue&type=style&index=0&id=797260eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797260eb",
  null
  
)

export default component.exports